import {Stack, Text} from '@treatwell/ui';
import {useAppSelector} from '../../hooks/store';
import {selectVenueData} from '../../store/slices/venue/slice';
import {AddServiceLink} from '../AddServiceLink';
import {useTranslation} from 'react-i18next';
import styles from './EmptyBasket.module.css';

export const EmptyBasket = () => {
  const {t} = useTranslation();
  const venueData = useAppSelector(selectVenueData);
  const text = t('emptyBasket.venueLink', {venueName: venueData.name});
  return (
    <div className={styles.root} data-cy="EmptyBasket">
      <Stack fullHeight justify="center" space="base" align="center">
        <Text as="p" type="lgHeader" className={styles.text}>
          {t('emptyBasket.emptyText')}
        </Text>
        <AddServiceLink url={venueData.uri} text={text} />
      </Stack>
    </div>
  );
};
